import script from "./slot-prop-watcher.vue?vue&type=script&lang=js"
export * from "./slot-prop-watcher.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__